module.exports = __webpack_public_path__ + "static/media/analytics.67473c2a.png";